@file:OptIn(InternalResourceApi::class)

package loco

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/loco/"

@delegate:ResourceContentHash(676_730_041)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", "USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20424, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20104, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20884, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18344, 67),
      ))
    }

@delegate:ResourceContentHash(-1_709_531_031)
public val Res.string.USER_AVATAR_PERMISSION_REQUIRED_TITLE: StringResource by lazy {
      StringResource("string:USER_AVATAR_PERMISSION_REQUIRED_TITLE", "USER_AVATAR_PERMISSION_REQUIRED_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20500, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20180, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20956, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18412, 73),
      ))
    }

@delegate:ResourceContentHash(-454_252_886)
public val Res.string.WEIGHT_HISTORY_SCREEN_TITLE: StringResource by lazy {
      StringResource("string:WEIGHT_HISTORY_SCREEN_TITLE", "WEIGHT_HISTORY_SCREEN_TITLE", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20578, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 20250, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21026, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18486, 63),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON", Res.string.USER_AVATAR_PERMISSION_REQUIRED_POSITIVE_BUTTON)
  map.put("USER_AVATAR_PERMISSION_REQUIRED_TITLE", Res.string.USER_AVATAR_PERMISSION_REQUIRED_TITLE)
  map.put("WEIGHT_HISTORY_SCREEN_TITLE", Res.string.WEIGHT_HISTORY_SCREEN_TITLE)
}
